var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "23 23 90 90",
    style: {
      enableBackground: "new 0 0 113.73 113.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CD1F38;}\n\t.st1{fill:#140F41;}\n\t.st2{fill:#453192;}\n\t.st3{fill:#DCDBDB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.61,74.5L44.61,74.5c-5.34,0-9.7-4.37-9.7-9.7V51.21c0-5.34,4.37-9.7,9.7-9.7h0c5.34,0,9.7,4.37,9.7,9.7 V64.8C54.31,70.14,49.94,74.5,44.61,74.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.79,51.46c-5.49,0-9.95-4.46-9.95-9.95s4.46-9.95,9.95-9.95s9.95,4.46,9.95,9.95S50.28,51.46,44.79,51.46z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 44.79,
    cy: 40.66,
    r: 7.95
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "42.1,32.71 42.1,36.69 44.79,38.78 44.79,32.08  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "47.49,32.71 47.49,36.69 44.79,38.78 44.79,32.08  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "40.74,71.93 37.46,67.83 37.49,51.8 38.62,48.46 39.57,48.78 38.46,52.04 38.46,67.48 41.52,71.3  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "48.58,71.93 47.8,71.3 50.85,67.48 50.85,52.04 49.75,48.78 50.69,48.46 51.85,51.96 51.85,67.83  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.71,72.63h-1.17l-0.59-1.01l0.59-1.02h1.17l0.59,1.02L41.71,72.63z M41.12,71.63l0.03-0.01l-0.03-0.02 l-0.01,0.02L41.12,71.63z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.77,72.63H47.6l-0.59-1.01l0.59-1.02h1.17l0.59,1.02L48.77,72.63z M48.18,71.63l0.03-0.01l-0.03-0.02 l-0.01,0.02L48.18,71.63z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.05,
    y: 41.31,
    className: "st1",
    width: 3.94,
    height: 1.5
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46.53,
    y: 41.31,
    className: "st1",
    width: 3.94,
    height: 1.5
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.94,74.5L68.94,74.5c-5.34,0-9.7-4.37-9.7-9.7V51.21c0-5.34,4.37-9.7,9.7-9.7h0c5.34,0,9.7,4.37,9.7,9.7 V64.8C78.65,70.14,74.28,74.5,68.94,74.5z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.13,51.46c-5.49,0-9.95-4.46-9.95-9.95s4.46-9.95,9.95-9.95s9.95,4.46,9.95,9.95S74.62,51.46,69.13,51.46z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 69.13,
    cy: 40.66,
    r: 7.95
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "66.43,32.71 66.43,36.69 69.13,38.78 69.13,32.08  "
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "71.83,32.71 71.83,36.69 69.13,38.78 69.13,32.08  "
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.07,71.93 61.8,67.83 61.83,51.8 62.96,48.46 63.91,48.78 62.8,52.04 62.8,67.48 65.86,71.3  "
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "72.91,71.93 72.13,71.3 75.19,67.48 75.19,52.04 74.08,48.78 75.03,48.46 76.19,51.96 76.19,67.83 "
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.05,72.63h-1.17l-0.58-1.01l0.58-1.02h1.17l0.58,1.02L66.05,72.63z M65.46,71.63l0.03-0.01l-0.03-0.02 l-0.01,0.02L65.46,71.63z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.11,72.63h-1.17l-0.59-1.01l0.59-1.02h1.17l0.58,1.02L73.11,72.63z M72.51,71.63l0.03-0.01l-0.03-0.02 l-0.01,0.02L72.51,71.63z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 63.38,
    y: 41.31,
    className: "st1",
    width: 3.94,
    height: 1.5
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.87,
    y: 41.31,
    className: "st1",
    width: 3.94,
    height: 1.5
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.95,81.77c0.85,0,1.34,0.47,1.34,1.28v1.69c0,0.82-0.5,1.28-1.34,1.28h-3.02c-0.09,0-0.14-0.05-0.14-0.13 V81.9c0-0.08,0.05-0.13,0.14-0.13H51.95z M50.02,85.05h1.49c0.41,0,0.56-0.12,0.56-0.47v-1.36c0-0.34-0.15-0.47-0.56-0.47h-1.49 V85.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.77,84.66c0,0.33,0.07,0.39,0.47,0.39h1.08c0.4,0,0.47-0.06,0.47-0.39V81.9c0-0.08,0.05-0.13,0.14-0.13 h0.95c0.08,0,0.14,0.05,0.14,0.13v3.15c0,0.68-0.3,0.97-1.02,0.97h-2.44c-0.71,0-1.02-0.29-1.02-0.97V81.9 c0-0.08,0.05-0.13,0.14-0.13h0.95c0.09,0,0.14,0.05,0.14,0.13V84.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.94,85.05c0,0.68-0.3,0.97-1.02,0.97h-2.6c-0.71,0-1.02-0.29-1.02-0.97v-2.31c0-0.68,0.32-0.97,1.02-0.97 h2.6c0.71,0,1.02,0.29,1.02,0.97V85.05z M63.71,83.14c0-0.33-0.07-0.39-0.47-0.39H62c-0.4,0-0.47,0.06-0.47,0.39v1.52 c0,0.33,0.07,0.39,0.47,0.39h1.24c0.4,0,0.47-0.06,0.47-0.39V83.14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuo);
export default __webpack_public_path__ + "static/media/duo.53b88a2cb076da818732f27a62641254.svg";
export { ForwardRef as ReactComponent };